<div *ngIf="showLoader" [@enterAnimation] id="loader"></div>
<app-bread-crumbs [startCategoryId]="startCategoryId"
    (currentCatChanged)="currentCatChanged($event)"></app-bread-crumbs>
<p *ngFor="let cat of dataCat">
    <a [routerLink]="[ '/catalog', cat.id]" routerLinkActive="active">{{cat.attributes.title}}</a>
    <a *ngIf="cat.attributes.description_page_sn" title="Подробнее" class="pl-1" [routerLink]="[ '/uni-page', cat.attributes.description_page_sn]" routerLinkActive="active">
        <i  class="fa fa-info-circle" aria-hidden="true"></i>
    </a>
</p>


<app-product-list></app-product-list>